<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ChangeHistory')"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :wrap-text="true"
      :style="{width:'100%',height:'450px'}"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateCrossTenantSyncHistory } from '@/api/booking/job'
import { getAllTenant } from '@/api/auth'

export default {
  name: 'CrossTenantChangeHistoryDialog',
  props: {
    visible: { type: Boolean, required: true },
    hasUnRead: { type: Boolean, required: true },
    jobUuid: { type: String, required: true },
    lob: { type: String, required: true },
    data: { type: Array, required: true, default: () => { return {} } }
  },
  data() {
    return {
      tenants: [],
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Source'),
          field: 'tenantId',
          suppressMenu: true,
          flex: 1,
          valueFormatter: (params) => {
            return this.tenantLabel(params)
          }
        }, {
          headerName: this.$t('SeaExport.DateModified'),
          field: 'dateCreated',
          suppressMenu: true,
          flex: 1
        }, {
          headerName: this.$t('SeaExport.Details'),
          field: 'updateDetailsDescription',
          suppressMenu: true,
          height: 100,
          flex: 1
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      getAllTenant().then(res => {
        this.tenants = res.data
        this.rowData = this.data
        this.toRead()
      })
    }
  },
  methods: {
    toRead() {
      updateCrossTenantSyncHistory({ jobKey: this.jobUuid }).then(res => {})
    },
    tenantLabel(params) {
      const field = this.lob === 'SE' ? 'sendTenantId' : 'receiveTenantId'
      for (const tenant of this.tenants) {
        if ((params.data[field] + '') === tenant.id) {
          return this.$store.getters.language === 'zh' ? tenant.name : tenant.englishName
        }
      }
      return ''
    }
  }
}
</script>

<style>
</style>
